import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Card from "components/card"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import React from "react"

/**
 * @typedef {object} ComponentsFrontLayoutMainCardProps
 * @property {unknown} children
 * @property {unknown} className
 */

/** @typedef {object} ComponentsFrontLayoutMainCardState */

/**
 * @extends {ShapeComponent<ComponentsFrontLayoutMainCardProps, ComponentsFrontLayoutMainCardState>}
 */
class ComponentsFrontLayoutMainCard extends ShapeComponent {
  render() {
    const {className, children, ...restProps} = this.props

    return (
      <div className="align-center" style={{width: "100%", height: "100%"}}>
        <Card className={classNames("components--main-card", className)} style={{flexGrow: 1}} {...restProps}>
          {children}
        </Card>
      </div>
    )
  }
}

export default memo(shapeComponent(ComponentsFrontLayoutMainCard))
